import React, { ChangeEvent, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { axiosGet } from "../../util/axios";
import { initDepotListThunk } from "../../redux/staticInfo/thunk";
import { OpenSnackBarWithResultFail } from "../../redux/common/snackBar/thunk";
import {
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    SelectChangeEvent,
} from "@mui/material";
import {
    ChangeUnloadCollectionDepotThunk,
    ChangeUnloadCollectionMetalThunk,
    ChangeUnloadCollectionPaperThunk,
    ChangeUnloadCollectionPlasticThunk,
    ChangeUnloadCollectionTotalWeightThunk,
} from "../../redux/collection/thunk";
import { CollectionTargetType } from "../../interface/form";

function EditUnloadDataForm() {
    const dispatch = useDispatch<IRootThunkDispatch>();
    const dataFetchedRef = useRef(false);
    const { selectedUnloadCollectionInfo } = useSelector(
        (state: IRootState) => state.collectionState
    );
    const { depotList } = useSelector(
        (state: IRootState) => state.staticInfoState
    );

    useEffect(() => {
        const controller = new AbortController();
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        getFormStaticInfo();
        return () => {
            controller.abort();
        };
    }, []);

    async function getFormStaticInfo() {
        if (depotList.length === 0) {
            const result = await axiosGet("/api/collection/depot/3");
            if (result.data.success) {
                dispatch(initDepotListThunk(result.data.depotList));
            } else {
                dispatch(OpenSnackBarWithResultFail("未能下載卸貨點"));
            }
        }
        return;
    }

    function handleChangeDepot(event: SelectChangeEvent<string>) {
        dispatch(ChangeUnloadCollectionDepotThunk(event.target.value));
    }

    function handleChangeWeight(
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        type: CollectionTargetType
    ) {
        switch (type) {
            case "metal":
                dispatch(
                    ChangeUnloadCollectionMetalThunk(
                        event.target.value,
                        selectedUnloadCollectionInfo?.paper_weight!,
                        selectedUnloadCollectionInfo?.plastic_weight!
                    )
                );
                break;
            case "paper":
                dispatch(
                    ChangeUnloadCollectionPaperThunk(
                        event.target.value,
                        selectedUnloadCollectionInfo?.metal_weight!,
                        selectedUnloadCollectionInfo?.plastic_weight!
                    )
                );
                break;
            case "plastic":
                dispatch(
                    ChangeUnloadCollectionPlasticThunk(
                        event.target.value,
                        selectedUnloadCollectionInfo?.metal_weight!,
                        selectedUnloadCollectionInfo?.paper_weight!
                    )
                );
                break;
            case "total_weight":
                dispatch(
                    ChangeUnloadCollectionTotalWeightThunk(event.target.value)
                );
                break;
        }
    }

    return (
        <>
            <Grid style={{ display: "flex", padding: "20px" }}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                        卸貨地點
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedUnloadCollectionInfo?.depot_id.toString()}
                        label="回收類型"
                        disabled
                        onChange={handleChangeDepot}
                    >
                        {depotList.map((depot, index) => (
                            <MenuItem
                                value={depot.depot_id}
                                key={`recylcable-${index}`}
                            >
                                {depot.depot_cn}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="outlined-basic"
                        label="磅飛重量（紙）"
                        variant="outlined"
                        type="number"
                        onChange={(e) => handleChangeWeight(e, "paper")}
                        disabled={
                            selectedUnloadCollectionInfo?.depot_id !== 2
                                ? true
                                : false
                        }
                        value={selectedUnloadCollectionInfo?.paper_weight}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="outlined-basic"
                        label="磅飛重量（金屬）"
                        variant="outlined"
                        type="number"
                        onChange={(e) => handleChangeWeight(e, "metal")}
                        disabled={
                            selectedUnloadCollectionInfo?.depot_id !== 2
                                ? true
                                : false
                        }
                        value={selectedUnloadCollectionInfo?.metal_weight}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="outlined-basic"
                        label="磅飛重量（塑膠）"
                        variant="outlined"
                        type="number"
                        onChange={(e) => handleChangeWeight(e, "plastic")}
                        disabled={
                            selectedUnloadCollectionInfo?.depot_id !== 2
                                ? true
                                : false
                        }
                        value={selectedUnloadCollectionInfo?.plastic_weight}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="outlined-basic"
                        label="總重量"
                        variant="outlined"
                        type="number"
                        disabled={
                            selectedUnloadCollectionInfo?.depot_id === 2
                                ? true
                                : false
                        }
                        onChange={(e) => handleChangeWeight(e, "total_weight")}
                        value={selectedUnloadCollectionInfo?.total_weight}
                    />
                </FormControl>
            </Grid>
        </>
    );
}

export default EditUnloadDataForm;
